import React, { Component } from "react"
import { consumerFirebase } from '../../config'
import { Container, Paper, Grid, Breadcrumbs, Link, Typography, TextField, Button,
         Table, TableBody, TableRow, TableCell
} from '@material-ui/core'
import HomeIcon from '@material-ui/icons/Home';
import ImageUploader from 'react-images-upload';
import uuid from 'uuid';
import { createKeyword } from '../../session/actions/keyword';

const style = {
   container: {
      paddingLeft: "5em"
   },
   paper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px",
   },
   link: {
      display: "flex"
   },
   homeIcon: {
      width: 20,
      height: 20,
      marginRight: "4px"
   },
   paperForm: {
      padding: "2em",
      marginTop: "2em",
      paddingBottom: "4em"
   },
   submit: {
      marginTop: "3em",
      marginBottom: "2em"
   },
   image: {
      height: "100px",
   },
}

class EditSubCategories extends Component {

   state = {
      company:{
         name: '',
         images: [],
      },
   };

   changeData = e => {
      let company_ = Object.assign({}, this.state.company);
      company_[e.target.name] = e.target.value;
      this.setState({
         company: company_
      })
   }

   uploadImages = images => {
      const { company } = this.state;
      const { id } = this.props.match.params;

      Object.keys(images).forEach(key => {
         let dinamicCode = uuid.v4();
         let nameImage = images[key].name;
         let extension = nameImage.split(".").pop();
         images[key].alias = (nameImage.split(".")[0] + "_" + dinamicCode + "." + extension).replace(/\s/g,"_").toLowerCase();
      })

      this.props.firebase.saveDocuments(images).then(urlImages => {
         company.images = company.images.concat(urlImages);

         this.props.firebase.db
         .collection("Restaurants")
         .doc(id)
         .set(company, { merge : true})
         .then(success => {
            this.setState({
               company
            })
         })
      })
   }

   dropImage = imageUrl => async () => {
      const { company } = this.state;
      const { id } = this.props.match.params;

      let imageID = imageUrl.match(/[\w-]+.(jpg|png|jpeg|gif|svg)/);
      imageID = imageID[0];
      
      await this.props.firebase.dropDocument(imageID);

      let imageList = this.state.company.images.filter(image => {
         return image !== imageUrl;
      })

     company.images = imageList;

      this.props.firebase.db
      .collection("Categories")
      .doc(id)
      .collection('SubCategory')
      .doc()
      .set(company, {merge: true})
      .then(success => {
         this.setState({
            company
         })
      })
   }

   async componentDidMount() {
      const {id} = this.props.match.params 

      const productCollection = this.props.firebase.db.collection("Categories").doc(id).collection('SubCategory');
      const productDB = await productCollection.doc(id).get();

      this.setState({
         company : productDB.data()
      })
   }

   saveProduct = () => {
      const { company } = this.state;
      const { id } = this.props.match.params;

      const searchText = company.name;
      const keywords = createKeyword(searchText);

      company.keywords = keywords;

      this.props.firebase.db
      .collection("Categories")
      .doc(id)
      .set(company, {merge: true})
      .then( success => {
         this.props.history.push("/categories");
      })

   }

   render(){
      let imageKey = uuid.v4();

      return (
         <Container style={style.container} xs={12} md={8}>
            <Paper style={style.paper}>
               <Grid container spacing={3}>
                  <Grid item xs={12} md={8}>
                     <Breadcrumbs aria-label="breadcrumb">
                        <Link color="inherit" style={style.link} href="/categories">
                           <HomeIcon style={style.homeIcon}/>
                        </Link>
                        <Typography color="textPrimary">Editar SubCategoria</Typography>
                     </Breadcrumbs>
                  </Grid>
               </Grid>
            </Paper>
            <Paper style={style.paperForm}>
               <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                     <TextField
                        name="name"
                        label="Nombre"
                        fullWidth
                        onChange={this.changeData}
                        value={this.state.company.name}
                     />
                  </Grid>
                  <Grid item xs={12} md={6}>
                     <TextField
                        name="category"
                        label="Descripción"
                        fullWidth
                        onChange={this.changeData}
                        value={this.state.company.category}
                     />
                  </Grid>
                 
            </Grid>
            </Paper>
            <Grid container justify="center">
               <Grid item xs={12} md={12}>
                  <ImageUploader
                     key = {imageKey}
                     withIcon={false}
                     buttonText="Seleccione las imagenes"
                     onChange={this.uploadImages}
                     imgExtension={[".jpg", ".gif", ".png", ".jpeg"]}
                     maxFileSize={5242880}
                  />
               </Grid>
            </Grid> 
            <Grid item xs={12} md={4} justify="center">
               <Table>
                  <TableBody>
                     {
                        this.state.company.images
                        ?this.state.company.images.map((image, i) =>  (
                           <TableRow key={i}>
                              <TableCell align="left">
                                 <img src={image} style={style.image}/>
                              </TableCell>
                              <TableCell>
                                 <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    onClick={this.dropImage(image)}
                                 >
                                    Eliminar
                                 </Button>
                              </TableCell>
                           </TableRow>
                        ))
                        :""
                     }
                  </TableBody>
               </Table>
                  </Grid> 
            <Grid container justify="center">
               <Grid item xs={12} md={6}>
                  <Button
                     type="button"
                     fullWidth
                     variant="contained"
                     size="large"
                     color="primary"
                     style={style.submit}
                     onClick={this.saveProduct}
                  >
                     Editar
                  </Button>
               </Grid>
            </Grid>

         </Container>
      )
   }
}

export default consumerFirebase(EditSubCategories);